import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

const Switch = () => {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") || false
  );

  if (darkMode) {
    document.documentElement.classList.add("dark");
    localStorage.setItem("darkMode", true);
  } else {
    document.documentElement.classList.remove("dark");
    localStorage.removeItem("darkMode");
  }

  return (
    <div className="flex col-span-1 justify-end">
      <button
        type="button"
        title="Toggle dark/light mode"
        onClick={() => setDarkMode(!darkMode)}
        className="flex items-center p-2 mr-2 text-xs font-medium text-gray-700 bg-white rounded-lg border border-gray-200 toggle-dark-state-example hover:bg-gray-100 hover:text-[#004366] focus:z-10 focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-500 dark:bg-gray-800 focus:outline-none dark:text-gray-[#004366] dark:border-gray-600 dark:hover:gray-700 dark:hover:bg-gray-700"
      >
        {darkMode ? (
          <SunIcon className="fill-current h-4 w-4" />
        ) : (
          <MoonIcon className="fill-current h-4 w-4" />
        )}
      </button>
    </div>
  );
};

export default Switch;
